import moment from "moment";
import momenttz from "moment-timezone"
import { MessageThreadModel } from "../models/MessageCenterModels";
import MonthlyGeneratedValues from "../data/MonthlyGeneratedValues.json";

export const getCompanyLocationNames = (
  companyName: any,
  locationName: any
) => {
  if (companyName && locationName) {
    if (companyName.length > 27 && locationName.length > 14) {
      return `${companyName.slice(0, 15)}...${companyName.slice(
        companyName.length - 4
      )} 
      ${"(" + locationName.slice(0, 15)}...${
        locationName.slice(locationName.length - 4) + ")"
      }`;
    } else if (companyName.length > 27) {
      return `${companyName.slice(0, 15)}...${companyName.slice(
        companyName.length - 4
      )} 
      ${"(" + locationName + ")"}`;
    } else if (locationName.length > 14) {
      return `${companyName} 
      ${"(" + locationName.slice(0, 15)}...${
        locationName.slice(locationName.length - 4) + ")"
      }`;
    } else {
      return companyName + " (" + locationName + ")";
    }
  } else {
    return companyName;
  }
};
export const getMonthlyDepositTextValue = (id: string | null | undefined) => {
  if (!id) return "- -";
  const item = MonthlyGeneratedValues.find((m: any) => m.bankText == id);
  if (item) {
    return item.text;
  }
  return "- -";
};

export const validateDate = (value: any) => {
  const dateformat =
    /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
  if (value?.match(dateformat)) {
    return true;
  } else {
    return false;
  }
};

export const formatDateOrDay = (dateString: string | null) => {
  const inputDate = moment(dateString);
  const currentDate = moment();

  const oneDay = 24 * 60 * 60 * 1000;
  const oneWeek = 7 * oneDay;

  if (dateString) {
    if (inputDate.isSame(currentDate, "day")) {
      return `Today at ${inputDate.format("HH:mm")}`;
    }

    if (currentDate.diff(inputDate, "milliseconds") < oneWeek) {
      return inputDate.format("dddd");
    }

    return inputDate.format("YYYY-MM-DD");
  } else {
    return "--";
  }
};
export const getDisplayValue = (value: any) => {
  if (!value) return "- -";
  if (value.length > 80) return value.slice(0, 79) + "...";
  return value;
};

export const emailTypes = [
  {
    id: 1,
    text: "Personal",
    value: "Personal",
  },
  {
    id: 2,
    text: "Work",
    value: "Work",
  },
  {
    id: 1,
    text: "Bussiness",
    value: "Bussiness",
  },
];

export const phoneTypes = [
  {
    id: 1,
    text: "Mobile/Cell",
    value: "Mobile/Cell",
  },
  {
    id: 2,
    text: "Home",
    value: "Home",
  },
  {
    id: 3,
    text: "Work",
    value: "Work",
  },
  {
    id: 4,
    text: "Fax",
    value: "Fax",
  },
];

const addZeros = (amount: any) => {
  if (amount.toString().indexOf(".") > -1) {
    if (amount.toString().length - 1 - amount.toString().indexOf(".") >= 2) {
      return amount;
    } else {
      return amount;
    }
  } else {
    return amount;
  }
};

/* return -- if value is null. Can be extended to ... or other common functionalities */
export const textFormatter = (
  value: string | null | undefined,
  singleDashValue = false
) => {
  if (value) return value;
  else if (singleDashValue) return "-";
  else return "--";
};

export const getAmountValue = (amount: any, showCurrency = true) => {
  if (
    amount === undefined ||
    amount === null ||
    (amount && amount?.length === 1 && amount.charAt(0) === "$")
  ) {
    return "- -";
  }
  let amountWithOutCommas = amount;
  if (amount.startsWith("$")) {
    amountWithOutCommas = parseFloat(amount.replace(/[\$,]/g, ""));
  } else {
    amountWithOutCommas = parseFloat(amount.replace(/,/g, ""));
  }

  if (Math.abs(Number(amountWithOutCommas)) >= 1.0e9) {
    return "$" + Math.abs(Number(amountWithOutCommas) / 1.0e9).toFixed(2) + "B";
  } else if (Math.abs(Number(amountWithOutCommas)) >= 1.0e6) {
    return (
      (showCurrency ? "$" : "") +
      Math.abs(Number(amountWithOutCommas) / 1.0e6).toFixed(2) +
      "M"
    );
  } else if (Math.abs(Number(amountWithOutCommas)) >= 1.0e3) {
    const nf = new Intl.NumberFormat("en-US");
    return addZeros((showCurrency ? "$" : "") + nf.format(amountWithOutCommas));
  } else if (0 <= Math.abs(Number(amountWithOutCommas <= 999))) {
    return (showCurrency ? "$" : "") + Math.abs(Number(amountWithOutCommas));
  }
};

export const valueEllipsis = (value: string, limit: number) => {
  if (value && limit > 0 && value?.length > limit)
    return `${value?.slice(0, limit)}...`;
  else return value;
};

export const sizeConversion = (bytes: number, decimal = 2) => {
  const k = 1024;
  const dm = decimal < 0 ? 0 : decimal;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  if (bytes < 0) return "";
  else if (bytes === 0) return "0 Bytes";
  else {
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
};

// dislay name based on the values available
export const getMessageThreadUserName = (
  messageThread: MessageThreadModel | undefined | null
) => {
  if (
    messageThread?.userDisplayFirstName &&
    messageThread?.userDisplayLastName &&
    messageThread?.clientCompany
  ) {
    return `${messageThread?.userDisplayFirstName} ${messageThread?.userDisplayLastName}
       - ${messageThread?.clientCompany}`;
  } else if (!messageThread?.clientCompany) {
    return `${messageThread?.userDisplayFirstName || "--"} ${
      messageThread?.userDisplayLastName
    }`;
  } else {
    return "--";
  }
};

export const getDisplayPhoneNumber = (value: any) => {
  if (!value || value === "+1") return "- -";
  if (value.length > 80) return value.slice(0, 79) + "...";
  return `+${value.replace("+", "")}`;
};

export const sendPhondNumberFormat=(value:any)=>{
  if(value){
    const cleanedNumber = value.replace(/\D/g, '');
  if (cleanedNumber.length > 7 && cleanedNumber[0] === '1') {
    const formattedNumber = `+1 (${cleanedNumber.slice(1, 4)}) ${cleanedNumber.slice(4, 7)}-${cleanedNumber.slice(7)}`;
    return formattedNumber;
  }
  else if(cleanedNumber.length < 7 && cleanedNumber[0] === '1'){
    const formattedNumber = `+1 (${cleanedNumber.slice(1, 4)}) ${cleanedNumber.slice(4)}`;
    return formattedNumber;
  }
  else if(cleanedNumber.length < 4 && cleanedNumber[0] === '1'){
    const formattedNumber = `+1 (${cleanedNumber.slice(1)})`;
    return formattedNumber;
  }
  }  
}

export const getSettingsEmail = (email: string) => {
  if (email?.length > 25) {
    return `${email?.slice(0, 20)}...${email?.slice(email?.length - 4)}`;
  } else {
    return email;
  }
};

export const getPercetSymbol = (value: string) => {
  const lastPercentIndex = value?.lastIndexOf("%");
  if (lastPercentIndex !== -1) {
    // If '%' is found, remove it and return the modified string
    if (value === null) {
      return 0;
    } else {
      return parseInt(
        value?.slice(0, lastPercentIndex) + value?.slice(lastPercentIndex + 1)
      );
    }
  } else {
    // If '%' is not found, return the original string
    return 0;
  }
};
export const interactionData = [
  {
    id: "2059a316-40b0-11ee-a5a4-024e9f1aefd6",
    value: "PhoneCall(s)",
    text: "PhoneCall(s)",
  },
  {
    id: "89a389d6-40b0-11ee-a5a5-024e9f1aefd6",
    value: "videoCall(s)",
    text: "VideoCall(s)",
  },
  {
    id: "c4c3212a-40b0-11ee-a5a6-024e9f1aefd6",
    value: "officeMeeting(s)",
    text: "OfficeMeeting(s)",
  },
  {
    id: "3492c470-2f9e-11ee-be56-0242ac120002",
    value: "Email(s)",
    text: "Email(s)",
  },
];

export const emailValidation = () => {
  // eslint-disable-next-line no-control-regex
  return /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
};

export const urlValidation = () => {
  // eslint-disable-next-line no-useless-escape
  return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/i;
};

export function formatTimestamp(timestampString: any) {
  if (timestampString) {
    const timestamp = moment(timestampString);
    const currentTime = moment();

    const duration = moment.duration(currentTime.diff(timestamp));
    const minutesDifference = duration.asMinutes();

    if (minutesDifference < 60) {
      return moment.duration(minutesDifference, "minutes").humanize() + " ago";
    } else if (minutesDifference < 1440) {
      return moment.duration(minutesDifference, "minutes").humanize() + " ago";
    } else {
      return moment(timestampString).format("MM/DD/YYYY , hh:mm A");
    }
  } else {
    return "--";
  }
}

export const dollarSymbol = (value: string) => {
  if (value) {
    if (value.charAt(0) !== "$") {
      return "$" + value;
    }
  }
  return value;
};

export const fileFormats = (values: any) => {
  return {
    "image/jpeg": [".jpeg", ".jpg"],
    "image/png": [".png"],
    "image/gif": [".gif"],
    "image/bmp": [".bmp"],
    "application/pdf": [".pdf"],
    "application/doc": [".doc"],
    "application/docx": [".docx"],
    "application/xls": [".xls"],
    "application/xlsx": [".xlsx"],
    "application/rtf": [".rtf"],
    "application/ppt": [".ppt"],
    "application/pptx": [".pptx"],
    "application/tiff": [".tiff"],
    "application/csv": [".csv"],
  };
};

export const catchErrorGeneric = (value: string) => {
  console.error(value || "");
};

export const fileFormatSupported=(fileType:string)=>{
  const fileSupport = ["jpg", "jpeg", "png", "pdf","xlsx", "gif", "docx","csv","xls"];
   if(fileType){
    return fileSupport.includes(fileType.toLowerCase());
   }
  
    return false
}

export const timeConversion=(time:string) =>{
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const momentObj = momenttz(time).tz(timezone);
  const time12 = momentObj.format('h:mm A z');

  return time12;
}

export const removeMilliSeconds=(time:string) => {
  
  const momentObj = moment(time, 'HH:mm:ss.SSS');
  const formattedTime = momentObj.format('HH:mm:ss');

  return formattedTime;
} 
